const logger = {
    warn(message) {
        if (import.meta.env.ENVIRONMENT !== 'prod') {
            /* tslint:disable:no-console */
            console.warn(message);
        }
    },
    info(message) {
        if (import.meta.env.ENVIRONMENT !== 'prod') {
            /* tslint:disable:no-console */
            console.info(message);
        }
    },
    log(message) {
        if (import.meta.env.ENVIRONMENT !== 'prod') {
            console.info(message);
        }
    },
};
export default logger;
//# sourceMappingURL=logger.js.map